import { render, staticRenderFns } from "./NewSceneMeta.vue?vue&type=template&id=5cdbfad0"
import script from "./NewSceneMeta.vue?vue&type=script&lang=js"
export * from "./NewSceneMeta.vue?vue&type=script&lang=js"
import style0 from "./NewSceneMeta.vue?vue&type=style&index=0&id=5cdbfad0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports